import React, { useCallback, useState, useEffect, useRef } from "react"
import { useHistory } from "react-router-dom"
import Form from "@bappweb/form"
import Panel from "@bappweb/panel"
import TextField from "@bappweb/textfield"
import Button from "@bappweb/button"
import Checkbox from "@bappweb/checkbox"
import Link from "@bappweb/link"
import Captcha from "@smpu-web/nested/form/captcha"
import FormMessage from "@smpu-web/globalmodules/form-message/index"
import Page from "@smpu-web/globalmodules/page"
import Element from "@bappweb/element"
import { useAppSelector } from "../../../config/hook"
import { numeric, RegexpTypes, required } from "@bappweb/utils"
import {
  useGetTokenByTckn1Mutation,
  useGetCaptchaMutation,
  useRefreshCaptchaMutation,
  useApply1Mutation
} from "../../../api/services"
import "../assets/style.scss"
import "../../../../../assets/styles/style.scss"
import Block from "@bappweb/block"

type PropsType = {
  onError?: (event?: React.BaseSyntheticEvent, errorField?: Record<string, any>) => void
  onSubmit?: (event?: React.BaseSyntheticEvent, values?: Record<string, any>) => void
  configValue: string
}

const getCid = () => {
  let search = window.location.search
  let params = new URLSearchParams(search)

  return params.get("cid")
}

function MainForm({ onError, onSubmit, configValue }: PropsType) {
  const history = useHistory()

  const [formValues, setFormValues] = useState({
    tckn: "",
    nameSurname: "",
    phone: ""
  })

  const [captchaValues, setCaptchaValues] = useState({
    tokenSessionId: "",
    captchaData: "",
    captcha: "",
    showCaptcha: false,
    captchaValidate: true
  })

  const [error, setError] = useState<string | null>(null)
  const [isFetching, setIsFetching] = useState(false)

  const refForm = useRef(null)

  const [getTokenByTckn1] = useGetTokenByTckn1Mutation()
  const handleChange = useCallback(
    (e) => {
      const name = e.target.name
      const value = e.target.value

      switch (name) {
        case "tckn":
          setError(null)
          setFormValues({
            ...formValues,
            tckn: value
          })
          setCaptchaValues({
            ...captchaValues,
            captchaData: "",
            tokenSessionId: "",
            showCaptcha: false
          })

          // @ts-ignore TODO
          // Captcha alanı temizlendiğinde validasyon hatası alıyor. O nedenle bu şekilde alanı temizliyoruz.
          refForm.current?.setValue("captcha", "")

          if ((value ?? "").length === 11) {
            setIsFetching(true)
            getTokenByTckn1(value)
              .unwrap()
              .then((payload) => {
                if (!payload.IsError) {
                  setError("")
                  setCaptchaValues({
                    ...captchaValues,
                    tokenSessionId: payload.tokenSessionId
                  })
                } else {
                  setError(payload.ErrorMessage ? payload.ErrorMessage : "")
                }
              })
              .finally(() => {
                setIsFetching(false)
              })
          }
          break
        case "name":
          setError(null)
          setFormValues({
            ...formValues,
            nameSurname: value
          })
          break
        case "phone":
          setError(null)
          setFormValues({
            ...formValues,
            phone: value
          })
          break
        case "captcha":
          setError(null)
          setCaptchaValues({
            ...captchaValues,
            captcha: value
          })
          break
        default:
          break
      }
    },
    [formValues, getTokenByTckn1, captchaValues]
  )

  const [getCaptcha] = useGetCaptchaMutation()
  useEffect(() => {
    if (captchaValues.captchaData === "" && captchaValues.tokenSessionId !== "") {
      setIsFetching(true)
      getCaptcha({
        tckn: formValues.tckn,
        TokenSessionId: captchaValues.tokenSessionId
      })
        .unwrap()
        .then((payload) => {
          if (!payload.IsError) {
            setCaptchaValues({
              ...captchaValues,
              captchaData: payload.captchaData,
              showCaptcha: true,
              captchaValidate: true
            })
          } else {
            setError(payload.ErrorMessage ? payload.ErrorMessage : "")
          }
        })
        .finally(() => {
          setIsFetching(false)
        })
    }
  }, [formValues, getCaptcha, captchaValues])

  const [refreshCaptcha] = useRefreshCaptchaMutation()
  const handleCaptchaRefresh = useCallback(() => {
    setIsFetching(true)
    refreshCaptcha({
      tckn: formValues.tckn,
      TokenSessionId: captchaValues.tokenSessionId
    })
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setCaptchaValues({
            ...captchaValues,
            captchaData: payload.captchaData,
            captchaValidate: true
          })
        } else {
          setError(payload.ErrorMessage ? payload.ErrorMessage : "")
        }
      })
      .finally(() => {
        setIsFetching(false)
      })
  }, [formValues, captchaValues, refreshCaptcha])

  const [apply1] = useApply1Mutation()
  const handleSubmit = useCallback(
    (e?: React.BaseSyntheticEvent, values?: Record<string, any>) => {
      if (values && captchaValues.captcha !== "") {
        setIsFetching(true)
        let cid = getCid()
        apply1({
          tckn: formValues.tckn,
          adSoyad: formValues.nameSurname,
          telefon: "0090" + values.phone.replace(/\s/g, ""),
          captcha: captchaValues.captcha.toUpperCase(),
          kvkk: values.checkboxKvkk,
          etk: true,
          cid: cid,
          TokenSessionId: captchaValues.tokenSessionId
        })
          .unwrap()
          .then((payload) => {
            if (!payload.IsError) {
              setError(null)
              history.push({
                pathname: "/result/success",
                state: payload
              })
            } else {
              setError(payload.ErrorMessage ? payload.ErrorMessage : "")
              window.scrollTo({
                top: 0
              })
              refreshCaptcha({
                tckn: formValues.tckn,
                TokenSessionId: captchaValues.tokenSessionId
              })
                .unwrap()
                .then((payload) => {
                  if (!payload.IsError) {
                    setCaptchaValues({
                      ...captchaValues,
                      captcha: "",
                      showCaptcha: true,
                      captchaData: payload.captchaData,
                      captchaValidate: false
                    })
                  } else {
                    setError(payload.ErrorMessage ? payload.ErrorMessage : "")
                  }
                })
                .finally(() => {
                  setIsFetching(false)
                })
            }
          })
          .finally(() => {
            setIsFetching(false)
          })
      }
    },
    [captchaValues, formValues, apply1, refreshCaptcha, history]
  )

  return (
    <Page>
      <Form onSubmit={handleSubmit} onChange={handleChange} grid={false} ref={refForm}>
        <Panel hasFooter connected={false} loading={isFetching}>
          <FormMessage className={"form-msg-error"} error={error}></FormMessage>
          <Panel.Body>
            <Element type="h1" className="bapp-panel-body-card-description">
              Size Özel 1e1 Bankacılık Başvurusu
            </Element>
            <TextField
              label="Adınız Soyadınız"
              type="text"
              name="name"
              placeholder="Adınız Soyadınız"
              maxLength={100}
              value={formValues.nameSurname}
              validator={RegexpTypes.AlphaTr}
              validations={[required("Bu alan zorunludur.")]}
            />
            <TextField
              label="TC Kimlik Numarası"
              type="number"
              name="tckn"
              placeholder="TC Kimlik Numarası"
              maxLength={11}
              value={formValues.tckn}
              validator={RegexpTypes.Numeric}
              validations={[required("Bu alan zorunludur."), numeric()]}
            />
            <TextField
              label="Cep Telefon No"
              type="text"
              name="phone"
              placeholder="5__ ___ __ __"
              mask="999 999 99 99"
              maxLength={13}
              value={formValues.phone}
              getMaskedValue={true}
              validations={[required("Bu alan zorunludur.")]}
            />
            {captchaValues.showCaptcha && (
              <Captcha
                label="Güvenlik Kodu"
                id="captcha"
                type="text"
                name="captcha"
                placeholder="Güvenlik Kodu"
                captcha={captchaValues.captchaData}
                value={captchaValues.captcha}
                maxLength={4}
                maxRefreshCount={3}
                refreshClick={handleCaptchaRefresh}
                validations={[required("Lütfen güvenlik kodunu giriniz.")]}
              />
            )}
            <div className="checkbox-group">
              <Checkbox
                className="cb-position-fix"
                name="checkboxKvkk"
                validations={[required("Lütfen onay kutusunu işaretleyiniz.")]}
                validateOnSubmit={true}
                block>
                {
                  "AKBANK T.A.Ş. olarak kişisel verilerini önemsiyoruz. 6698 nolu Kişisel Verilerin Korunması Kanunu kapsamında kişisel verilerinin işlenmesinden doğan haklarına ve bu konudaki detaylı bilgiye "
                }
                <Link
                  href="//www.akbank.com/Documents/KISISELVERILERINKORUNMASI_TR.pdf"
                  text={" aydınlatma metninden"}
                  inline
                  target="_blank"
                />
                {" ulaşabilirsiniz."}
              </Checkbox>
            </div>
          </Panel.Body>
          <Panel.Footer>
            <Panel.RightFooter>
              <Button text="DEVAM" type="submit" fetching={isFetching} disabled={isFetching} />
            </Panel.RightFooter>
          </Panel.Footer>
        </Panel>
      </Form>
      <Block dangerouslySetInnerHTML={{ __html: configValue }} />
    </Page>
  )
}

export default MainForm
